var _path, _path2, _path3, _line, _rect, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarnGlobaly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 56,
    viewBox: "0 0 67 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 45C34.3741 45 44 35.1503 44 23C44 10.8497 34.3741 1 22.5 1C10.6259 1 1 10.8497 1 23C1 35.1503 10.6259 45 22.5 45Z",
    stroke: "#14A800",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 23H44",
    stroke: "#14A800",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4277 1C30.2312 5.96778 34.827 14.8425 35 23C34.827 31.1575 28.9306 39.6065 22.4277 45C14.1908 39.6065 10.173 31.1575 10 23C10.173 14.8425 14.6243 5.96778 22.4277 1Z",
    stroke: "#14A800",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22.5,
    y1: 1,
    x2: 22.5,
    y2: 45,
    stroke: "#14A800"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 25,
    width: 28,
    height: 22,
    rx: 6,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5455 28H31.4545C29.5467 28 28 29.511 28 31.375V51.625C28 53.489 29.5467 55 31.4545 55H62.5455C64.4533 55 66 53.489 66 51.625V31.375C66 29.511 64.4533 28 62.5455 28Z",
    stroke: "#14A800",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 38H66",
    stroke: "#14A800",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnGlobaly);
export default __webpack_public_path__ + "static/media/earn-globaly.732d5887db7d54200c6f2ccd273f022a.svg";
export { ForwardRef as ReactComponent };